export default "__VITE_PUBLIC_ASSET__6924fdb0__"